<template>
   <!-- for each choice, set the available radio choices and restore the selected option -->
   <div v-for="choice in choices" :key="choice.id">
      <div class="radio-block cursor-pointer">
         <div class="radio-block-bg mb-3 flex min-h-12 w-full items-center rounded-md bg-grey-10">
            <input
               :id="`single-choice-item-${choice.id}`"
               :data-cy="`single-choice-item-${choice.id}`"
               type="radio"
               :name="group"
               :value="choice.id"
               class="absolute right-0 z-1 mr-6"
               :checked="choice.isSelected"
               :disabled="isDisabled"
               @change="updateChoice"
            />
            <label
               :for="`single-choice-item-${choice.id}`"
               class="radio-block-label flex min-h-12 w-full cursor-pointer items-center rounded-md"
            >
               <span class="py-4 pl-6 pr-16">{{ choice.label }}</span>
            </label>
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["choice-updated"]);

interface Choice {
   id: string;
   label: string;
   isSelected: boolean;
}

interface Props {
   choices: Choice[];
   group: string;
   isDisabled?: boolean;
}

// props
// -----------------------------------------
const props = withDefaults(defineProps<Props>(), {
   isDisabled: false,
});

// component methods
// -----------------------------------------
function updateChoice(event) {
   const selectedChoice = props.choices.find((choice) => choice.id === event.target.value);
   if (selectedChoice) {
      // Create a new object without the isSelected property
      const { isSelected, ...choiceWithoutSelected } = selectedChoice;
      emit("choice-updated", choiceWithoutSelected);
   }
}
</script>

<style scoped lang="scss">
.radio-block .radio-block-bg input {
   accent-color: white;
}
.radio-block .radio-block-bg input:checked {
   background: var(--colour-brand-background);
   accent-color: white;
}
.radio-block .radio-block-bg input:checked + .radio-block-label {
   background: var(--colour-brand-background);
   color: white;
}
</style>
